import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, VoidFunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { UserGroupListItem } from '../UserGroupListItem/UserGroupListItem';

export type UserGroupListProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  userGroups: Array<UserGroup>;
};

export const UserGroupList: VoidFunctionComponent<UserGroupListProps> =
  React.memo((props) => {
    const { userGroups, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <div {...remainingProps}>
        {userGroups.map((ug) => (
          <UserGroupListItem
            key={EntityUtils.getTrackingKey(ug)}
            userGroup={ug}
            data-testid="UserGroupList.ListItem"
          ></UserGroupListItem>
        ))}
      </div>
    );
  });
